import { Form, Input, Select } from 'antd';
import { useState, useCallback, useEffect } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { City } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function CityEditPage(props: { city?: City; onSaved: (country?: City) => void; onCancel: () => void }) {
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState<any>();
  const [countriesLoading, setCountriesLoading] = useState(false);

  const formValues: any = {
    ...props.city,
    countryId: props?.city?.country.id,
  };

  const loadCountries = useCallback(() => {
    setCountriesLoading(true);
    apiClient
      .get('countries')
      .then(response => {
        setCountries(response.data);
        setCountriesLoading(false);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
        setCountriesLoading(false);
      });
  }, []);

  useEffect(() => {
    loadCountries();
  }, [loadCountries]);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.city) {
      apiClient
        .post('cities', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`cities/${props.city?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={formValues}>
      <Form.Item
        label="Şehir"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="countryId"
      >
        <Select loading={countriesLoading}>
          {countries?.map((m: City) => (
            <Select.Option key={m.id} value={m.id}>
              {m.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
